import React from 'react'

const GlobalFilter = () => {
    return (
        <div>

        </div>
    )
}

export default GlobalFilter
